import React from 'react';
import { View, StyleSheet, Pressable } from 'react-native';

import { Text } from '~/components/core';
import { Ionicons } from '~/components/core/Icons';
import ScrollbarWrapper from '~/components/core/ScrollbarWrapper';
import DesktopScreenHeader from '~/components/features/Desktop/DesktopScreenHeader';
import { useStyles } from '~/hooks';
import { linkTo } from '~/navigation';
import paths from '~/navigation/paths';
import { scaleSize, isDesktop } from '~/constants/scale';
import { Theme } from '~/theme';
import { FONT_SIZE_S } from '~/constants';

type Props = {
    setActiveRightTab?: Function;
};

type Entry = {
    labelKey: string;
    tabId: string;
    path: string;
};

const ENTRIES: Entry[] = [
    { labelKey: 'terms-of-business', tabId: 'terms-of-business', path: paths.termsOfBusiness },
    { labelKey: 'order-execution-policy', tabId: 'order-execution-policy', path: paths.orderExecutionPolicy },
    { labelKey: 'risk-disclosure-notice', tabId: 'risk-disclosure-notice', path: paths.riskDisclosureNotice },
    /*{ labelKey: 'privacy-policy', tabId: 'privacy-policy', path: paths.privacyPolicy },*/
    { labelKey: 'copy-trading-agreement', tabId: 'copy-trading-agreement', path: paths.copyTradingAgreement },
];

export default function LegalDocuments({ setActiveRightTab }: Props) {
    const styles = useStyles(stylesGenerator);

    const go = (entry: Entry) => {
        if (isDesktop() && setActiveRightTab) {
            setActiveRightTab(entry.tabId);
        } else {
            linkTo(entry.path);
        }
    };

    return (
        <ScrollbarWrapper>
            {setActiveRightTab ? (
                <DesktopScreenHeader title="legal-documents" goToScreenName="more" setActiveRightTab={setActiveRightTab} />
            ) : null}
            <View style={styles.container}>
                <View style={styles.linksContainer}>
                    {ENTRIES.map((entry) => (
                        <Pressable
                            key={entry.labelKey}
                            style={styles.linkContainer}
                            onPress={() => go(entry)}
                        >
                            <View style={styles.iconCircle}>
                                <Ionicons
                                    name="document-text-outline"
                                    size={scaleSize(12)}
                                    style={styles.iconColor}
                                />
                            </View>
                            <Text fontType="LATO_REGULAR" style={styles.linkText}>
                                {entry.labelKey}
                            </Text>
                        </Pressable>
                    ))}
                </View>
            </View>
        </ScrollbarWrapper>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        container: {
            flex: 1,
            paddingHorizontal: scaleSize(15),
            paddingTop: scaleSize(10),
        },
        linksContainer: {
            width: '100%',
        },
        linkContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: scaleSize(8),
        },
        iconCircle: {
            width: scaleSize(24),
            height: scaleSize(24),
            borderRadius: scaleSize(12),
            backgroundColor: theme.background_closeTradeButtonPressed,
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: scaleSize(10),
        },
        iconColor: {
            color: theme.wallet_text,
        },
        linkText: {
            fontSize: FONT_SIZE_S,
            color: theme.wallet_text,
        },
    });
